// Will be changed to 'Upcoming_match_banner'.

const mu_banner = $('.pbl-team_banner');
let event_data, team_logo, is_season_over = true;

// Format the event date (to display on the left-side of the banner)
function formatDate(d, size) {
  let date = new Date(d),
      month = date.toLocaleDateString('default', {month: 'long'}),
      day = date.toLocaleDateString('default', {weekday: 'long'}),
      weekday = date.getDate();

  if(size === 'large'){
    return `${day}, <br class="lg-only"> ${month} ${weekday}`;
  } else if(size === 'small'){
    return `${day}, ${month} ${weekday}`
  }
  return `${day}, ${month} ${weekday}`;
}

// Retrieve Next Event data
function getUpcomingEvent() {
  $.ajax({ 
      url: 'https://tnp.mysites.io/wp-json/pbl/v1/upcoming-event',
      dataType: 'text'
  })
  .done((res) => {
      $(".pbl-loading__banner").fadeIn();

      // Determine if there are no longer any events availabe in WP_DB.
      // Will stop any error from stoping the runtime of this javascript file (Try & Catch).
      try {
        event_data = JSON.parse(res);   
      }
      catch(err) {
        if(err) {
          console.log(err);
          is_season_over = true;
        }
      }

      init_banner();
      $(".pbl-loading__banner").hide();
      $(".match-up_banner").fadeIn();    
  })
  .fail((res) => {
      console.log('Failed to retrieve old episodes!');
  })
}

//Create the banner for the webpage.
function dynamicMatchUpBanner() {
  let teamOneBanner, teamTwoBanner;
  if(event_data !== undefined && is_season_over !== true) {
    mu_banner.append(
      `<div class="pbl-team_bg-left">` + `</div>`+
      `<div class="pbl-team_bg-right">` + `</div>`+
      `<div class="container match-up_banner" style="display:none;">`+
        `<div class="row pbl-team_banner__row">`+
          `<div class="col-12 text-center pbl-team_banner__row__mobile-header md-only">`+
            `<span class="pbl-team_banner--date-mobile">${formatDate(event_data[0]['end_date'], 'small')}</span>`+
          `</div>`+
          `<div class="col-6 pbl-team_banner__row--left stretch">`+
            `<span class="pbl-team_banner--date md-hide">${formatDate(event_data[0]['end_date'], 'large')}</span>`+
            `<img class="team-logo" src="${event_data[0]['teams'][0]['team_1']['team_logo']}" alt="${event_data[0]['teams'][0]['team_1']['team_title']}">`+
          `</div>`+
          `<img class="pbl-team_banner--vs_logo" src="//www.jigsawhealth.com/cdn/shop/t/153/assets/icon--pbl-vs.svg?v=83660821846557992061788195430" alt="VS" >`+
          `<div class="col-6 pbl-team_banner__row--right stretch">`+
            `<img class="team-logo" src="${event_data[0]['teams'][1]['team_2']['team_logo']}" alt="${event_data[0]['teams'][1]['team_2']['team_title']}">`+
            `<div class="pbl-team_banner--btn_wrap md-hide" style="padding-top: 26px; padding-bottom: 27px;">`+
              `<a href="${event_data[0]['buy_button_link']}" class="pbl-team_banner--btn">`+
                `<span>Buy Tickets</span>`+
              `</a>`+
              `${(()=> event_data[0]['youtube_link'] !== '' ? `<a href="${event_data[0]['youtube_link']}" class="pbl-team_banner--btn"><span>Watch Now</span></a>` : '')()}`+
            `</div>`+
          `</div>`+
          `<div class="col-4 text-center pbl-team_banner__row__mobile-buttons md-only">`+
           `<div class="pbl-team_banner--btn_wrap">`+
              `<a href="${event_data[0]['buy_button_link']}" class="pbl-team_banner--btn">`+
                `<span>Buy Tickets</span>`+
              `</a>`+
              `<a href="https://youtube.com/live/SvFjpySeYdY?feature=share" class="pbl-team_banner--btn">`+
                `<span>Watch on The Dink</span>`+
              `</a>`+
            `</div>`+
          `</div>`+
        `</div>`+
      `</div>`
    )
  }

  if(is_season_over === true) {
    mu_banner.addClass('coming-soon');
    mu_banner.addClass('container');
    mu_banner.find('.pbl-loading__banner').remove();

    mu_banner.append(
      `<div class="row text-center row--justify-content-center row--align-items-center" style="padding:24px 0">`+
        `<h2 class="pbl-team__banner--announcement" style="margin-bottom:24px; width:100%">Latest News</h2>`+
        `<p style="color:white;margin-bottom:24px; font-size: 16px">Arizona Pickleball League is currently on hiatus while Team Jigsaw is working on another exciting project.<br/>Please subscribe to be notified of future updates.</p>`+
        `<a class="orchard-subscribe__mock-form klaviyo_form_trigger" data-remodal-target="orchard-subscribe-modal" role="button">`+
          `<img class="sm-hide" src="https://cdn.shopify.com/s/files/1/0286/5666/4654/files/inline-btn-graphic-desktop.svg?v=1648240953" alt="Click to Subscribe">`+
          `<img class="sm-only" src="https://cdn.shopify.com/s/files/1/0286/5666/4654/files/inline-btn-graphic-mobile.svg?v=1648240953" alt="Click to Subscribe">`+
        `</a>`+
      `</div>`
    )
  }

  // Change the color of the team banners
  if(event_data !== undefined && is_season_over !== true) {
    teamOneBanner = $('.pbl-team_bg-left');
    teamTwoBanner = $('.pbl-team_bg-right');
  
    teamOneBanner.css("background-color", `${event_data[0]['teams'][0]['team_1']['team_color']}`);
    teamTwoBanner.css("background-color", `${event_data[0]['teams'][1]['team_2']['team_color']}`);
  }
}

function init_banner() {
  //dynamicMatchUpBanner(); // Create and populate dynamic banner according to event data
}

getUpcomingEvent();